import { Card } from "antd";
import type { CardProps } from "antd";

export type BaseCardProps = CardProps;

const BaseCard = (props: BaseCardProps) => <Card {...props} />;

export default BaseCard;
